module.exports = __webpack_public_path__ + "static/media/ApplePayFlat.79dde859.svg";